import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {Router} from '@angular/router';
import {StorageService} from '../service/storage.service';
import {Toaster, Type} from '../toaster/Toaster';
import {SessionExpiredError} from '../errors/SessionExpiredError';
import {InternalServerError} from '../errors/InternalServerError';

@Injectable()
export class SessionExpiryErrorHandler implements ErrorHandler {
    private injector: Injector;

    constructor(injector: Injector) {
        this.injector = injector;
    }

    handleError(error: any): void {
        const storageService = this.injector.get(StorageService);
        const router = this.injector.get(Router);

        if (error instanceof SessionExpiredError) {
            storageService.clearSessionAndLocalStorage();

            Toaster.toast('Your session has expired. Please login again.', Type.Error);

            const routerState = router.routerState.snapshot;
            router.navigate(['/login'], {queryParams: {'redirectUrl': routerState.url}});
        } else if (error instanceof InternalServerError) {
            Toaster.toast('Something went wrong. Please try again later.', Type.Error);
        } else {
            console.error(error);
        }
    }
}